import { useMemo } from 'react'
import PropTypes from 'prop-types'

import { isHideMedia } from 'modules/discover/discoverUtils'
import HighlightsSlider from './HighlightsSlider/HighlightsSlider'
import styles from './Highlights.module.scss'

const Highlights = ({ investment: { logo, promoVideo, brandVideo, media } }) => {
  const videos = useMemo(
    () => [...(promoVideo ? [promoVideo] : []), ...(brandVideo ? [brandVideo] : [])],
    [promoVideo, brandVideo]
  )
  const videosTumbs = useMemo(
    () => [
      ...(promoVideo ? [logo] : []),
      ...(brandVideo ? ['https://assets.moneymade.io/images/logos/Vector.svg'] : [])
    ],
    [brandVideo, promoVideo, logo]
  )

  const hideMediaValue = useMemo(() => isHideMedia(videos, media), [videos, media])

  return !hideMediaValue ? (
    <div className={styles.Highlights}>
      {(!!media.length || !!videos.length) && <HighlightsSlider videosData={{ videos, videosTumbs }} medias={media} />}
    </div>
  ) : null
}

Highlights.propTypes = {
  investment: PropTypes.shape({
    logo: PropTypes.string,
    promoVideo: PropTypes.string,
    promoVideoThumb: PropTypes.string,
    brandVideo: PropTypes.string,
    brandVideoThumb: PropTypes.string,
    media: PropTypes.arrayOf(PropTypes.string)
  })
}

Highlights.defaultProps = {
  investment: {
    logo: '',
    promoVideo: '',
    promoVideoThumb: '',
    brandVideo: '',
    brandVideoThumb: ''
  }
}

export default Highlights
